export const REGISTERED_MARK = '®'
export const DEFAULT_ONLINE_ORDERING_URL = '/online-ordering'
export const SHOPIFY_URL = 'https://l-l-hawaiian-barbecue.myshopify.com'
